import { gql, useMutation } from '@apollo/client';

import { GET_BROKERAGE } from './entities.brokerage.details.query';

const DELETE_BROKERAGE_TEAM_MUTATION = gql`
  mutation DeleteTeamFromEntity($entity_uuid: String!, $team_uuid: String!) {
    deleteTeamFromEntity(entityUuid: $entity_uuid, teamUuid: $team_uuid) {
      result
      nodesDeleted
      relationshipsDeleted
    }
  }
`;

export function DeleteBrokerageTeam() {
  const [DeleteTeamFromEntity, { data, loading, error, reset }] = useMutation(
    DELETE_BROKERAGE_TEAM_MUTATION,
    {
      refetchQueries: [GET_BROKERAGE],
      awaitRefetchQueries: true,
    }
  );

  return {
    data,
    DeleteTeamFromEntity,
    loading,
    error,
    reset,
  };
}
